module.exports = __webpack_public_path__ + "static/media/gal-11.5536a90f.jpeg";